module.exports = __webpack_public_path__ + "img/types_of_ownership.9b852426.jpg";